// extracted by mini-css-extract-plugin
export default {"noticeContainer":"NoticeCard_noticeContainer__mZJru","noticeTable":"NoticeCard_noticeTable__SGTMv","noticTitle":"NoticeCard_noticTitle__Uqv9+"};